import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { ICrudGetAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './video-view-history.reducer';
import { IVideoViewHistory } from 'app/shared/model/video-view-history.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IVideoViewHistoryDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const VideoViewHistoryDetail = (props: IVideoViewHistoryDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { videoViewHistoryEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          VideoViewHistory [<b>{videoViewHistoryEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="viewedDate">Viewed Date</span>
          </dt>
          <dd>
            {videoViewHistoryEntity.viewedDate ? (
              <TextFormat value={videoViewHistoryEntity.viewedDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="currentTicker">Current Ticker</span>
          </dt>
          <dd>{videoViewHistoryEntity.currentTicker}</dd>
          <dt>Video Meta Data</dt>
          <dd>{videoViewHistoryEntity.videoMetaData ? videoViewHistoryEntity.videoMetaData.id : ''}</dd>
          <dt>User</dt>
          <dd>{videoViewHistoryEntity.user ? videoViewHistoryEntity.user.login : ''}</dd>
        </dl>
        <Button tag={Link} to="/video-view-history" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/video-view-history/${videoViewHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ videoViewHistory }: IRootState) => ({
  videoViewHistoryEntity: videoViewHistory.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(VideoViewHistoryDetail);
